import { Divider, Typography } from '@mui/material'
import { styled, SxProps, Theme } from '@mui/system'

const Header = styled(Typography)<{ headerStyles?: React.CSSProperties }>(({ headerStyles }) => ({
  fontSize: '13px',
  color: '#363752',
  ...(headerStyles ?? {}),
}))

type SidebarSectionProps = {
  header?: string
  showDivider?: boolean
  dividerStyles?: SxProps<Theme>
  headerStyles?: SxProps<Theme>
  children?: React.ReactNode
}

const SidebarSection: React.FC<SidebarSectionProps> = ({
  header,
  showDivider = false,
  dividerStyles = {},
  headerStyles = {},
  children,
}) => {
  return (
    <>
      {showDivider && <Divider sx={dividerStyles} />}
      {header && (
        <Header variant="h6" sx={headerStyles}>
          {header}
        </Header>
      )}
      {children}
    </>
  )
}

export default SidebarSection
